import { capitalize } from 'lodash-es';
import { Icon } from '@components/icon/Icon';
import type { AnyIcon } from '@components/icon/Icon';
import typography from '~styles/typography.scss';
import styles from './NoAvailabilities.scss';

const DEFAULT_ICON = 'table';
const DEFAULT_TITLE = 'No Availability';

interface NoAvailabilitiesProps {
  children: React.ReactNode;
  iconName?: AnyIcon;
  title?: string;
}

export const NoAvailabilities = ({
  children,
  iconName = DEFAULT_ICON,
  title = DEFAULT_TITLE,
}: NoAvailabilitiesProps) => {
  const iconLabel = `${capitalize(iconName)} Icon`;

  return (
    <div className={styles.container}>
      <div className={styles.circle}>
        <Icon ariaLabel={iconLabel} className={styles.icon} name={iconName} />
      </div>
      <h2 className={typography.d3}>{title}</h2>
      {children}
    </div>
  );
};
